import { Pipe, PipeTransform } from '@angular/core';

import { makeStylesForTag, TagColorPalette } from '@blaze-runtime/engine-domain';

@Pipe({
  name: 'stylesForTag',
})
export class StylesForTagPipe implements PipeTransform {
  transform(
    value: string,
    palette: TagColorPalette | undefined,
    defaultPalette?: { foreground?: string; background?: string },
  ): {
    color?: string;
    background?: string;
  } {
    return makeStylesForTag(value, palette, defaultPalette);
  }
}
